import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SettingsDrawerService {
    public settingsDrawerToggleSubject: BehaviorSubject<number> = new BehaviorSubject(0);
    private isDrawerOpened: BehaviorSubject<boolean> = new BehaviorSubject(false);

    isDrawerOpened$ = this.isDrawerOpened.asObservable();

    constructor() { }

    public toggleDrawer() {
        this.settingsDrawerToggleSubject.next(this.settingsDrawerToggleSubject.value + 1);
        this.setDrawerOpened(true);
    }

    setDrawerOpened(opened: boolean): void {
        this.isDrawerOpened.next(opened);
    }
}